<template>
  <div
    v-if="filtres.length"
    class="d-flex overflow-x"
  >
    <div
      v-for="(filtre, index) in filtres"
      :key="index"
    >
      <v-chip
        class="pa-5 border-chip ma-1"
        color="white primary--text"
      >
        <div class="texte primary--text">
          {{ filtre.libelle }}
        </div>
        <v-icon
          right
          @click="deleteFiltre(filtre)"
        >
          mdi-close
        </v-icon>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltreContratChips',
  props: {
    /**
     * Exemple object : [{
     *   type: "filtresRegions"
     *   libelle: "REGION CALVADOS OUEST"
     * }, {
     *   type: "typeContrat"
     *   libelle: "Prix campagne"
     * }]
     */
    filtres: {
      type: Array,
      default: null
    }
  },
  methods: {
    deleteFiltre (filtre) {
      this.$emit('delete', filtre)
    }
  }
}
</script>
<style lang="scss" scoped>
.border-chip {
  border-radius: 20px !important;
  border: 1px solid var(--gris-clair) !important;
}

.overflow-x {
  overflow-x: auto;
}
</style>